module.exports = __webpack_public_path__ + "assets/a63d8d7a212f81835d56ab5e6a276b54.png";